export default class Cookie {
    constructor(settings = {
        name: 'cookieName',
        expiryDays: 365
    }) {
        this.settings = settings;
    }

    get() {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${this.settings.name}=`);

        return parts.length !== 2 ? null : parts.pop().split(';')
            .shift();
    }

    set(value, expiryDays, domain, path) {
        const now = new Date();

        now.setDate(now.getDate() + (expiryDays || 365));

        const cookie = [
            `${this.settings.name}=${value}`,
            `expires=${now.toUTCString()}`,
            `path=${(path || '/')}`
        ];

        if (domain) {
            cookie.push(`domain=${domain}`);
        }

        document.cookie = cookie.join(';');
    }
}